import axios from './axios';
import authService from '../../app/services/authService';

function withAuth(config = {}) {
    const token = authService.getAccessToken();
    const headers = { ...(config.headers || {}) };
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    return { ...config, headers };
}

function toError(error) {
    const data = error.response?.data;
    const isJson = data && typeof data === 'object' && !(data instanceof Blob);
    if (isJson) {
        return {
            success: false,
            errorCode: error.response?.status,
            message: data.message || error.message,
            ...data,
        };
    }
    return {
        success: false,
        errorCode: error.response?.status,
        message: error.message,
    };
}

function request(config) {
    return axios.request(withAuth(config)).then(
        (response) => response.data,
        (error) => toError(error),
    );
}

function saveBlob(data, filename) {
    const blobUrl = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
}

export const api = {
    get(url, config) {
        return request({ url, method: 'get', ...config });
    },
    post(url, data, config) {
        return request({ url, method: 'post', data, ...config });
    },
    delete(url, config) {
        return request({ url, method: 'delete', ...config });
    },
    async download(url, { method = 'get', params, data, filename } = {}) {
        const result = await request({ url, method, params, data, responseType: 'blob' });
        if (!(result instanceof Blob)) {
            return result;
        }
        saveBlob(result, filename);
        return result;
    },
};
